import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, ElementRef, Inject, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { TranslateService } from '@ngx-translate/core';
import { cloneControl } from 'app/e-form/helper/script/cloneAbstract';
import { HelperTransalaterService } from 'app/e-form/service/helper-translate.service';
import { MessageBoxComponent } from 'app/shared/message-box/message-box';
import { EditDialogComponent } from '../edit-dialog/edit-dialog.component';

@Component({
  selector: 'app-name-customize',
  templateUrl: './name-customize.component.html',
  styleUrls: ['./name-customize.component.scss']
})
export class NameCustomizeComponent implements OnInit {
   @ViewChildren('input_req') divs: QueryList<ElementRef>;
   displayedColumns = ['drag', 'menu'];
   langSource = [];
   tmpEform: FormArray;
   duplicateType = '';
   langSupport = [];
   isEdit = false;
   original = this.data.eForm.controls.original.value;
   tmpDataSource = [];
   isInvalidDragEvent = false;
   dataSource = new MatTableDataSource<any>(this.tmpDataSource);
   languageList = ['th', 'en', 'cn'];
   private _dynamicIndex = 0;
  constructor(private dialog: MatDialog, private dialogRef: MatDialogRef<NameCustomizeComponent>, @Inject(MAT_DIALOG_DATA) private data: any,
  public translate: TranslateService, private helperTranslater: HelperTransalaterService) { }

  ngOnInit(): void {
     this.initailizeDataSource();
     this.supplyInitsLabels();
     this.setPosition();
  }

  initailizeDataSource() {
   this.tmpEform = cloneControl<FormArray>(this.data.field);
   Object.keys(this.tmpEform.at(0).value).forEach(v => {
      if (v !== 'id') { this.langSupport.push(v); } });
   Object.keys(this.tmpEform.controls).forEach((_val) => {
      const _l = this.tmpEform.controls[_val];
      this.createRows(_l.value);
   });
   moveItemInArray(this.langSupport, this.langSupport.findIndex(v => v === this.original), 1);
}

setPosition() {
   const _menu = this.displayedColumns.findIndex(v => v === 'menu');
   moveItemInArray(this.displayedColumns, _menu, this.displayedColumns.length - 1);
}

createRows(data: Object[]) {
   const _dataArrayLabel = [];
   _dataArrayLabel.push(data);
   _dataArrayLabel.forEach(v => {
      if (v.en !== 'Other') {
         this.tmpDataSource.push(v);
      }
   });
}

supplyInitsLabels() {
   const _notDuplicated = (check) => this.displayedColumns.some(v => v === check);
   for (const [lang, value] of Object.entries(this.tmpDataSource)) {
      this.tmpDataSource.forEach(v => {
         Object.keys(v).forEach(s => {
            if (value[s] !== '' && !_notDuplicated(s) && s !== 'id' && s !== 'drag' && s !== 'menu') {
               this.displayedColumns.push(s);
               return;
            }
         });
      });
   }
   if (!_notDuplicated(this.data.eForm.controls.original.value)) {
      this.displayedColumns.push(this.data.eForm.controls.original.value);
   }
   const _index = this.displayedColumns.findIndex(v => v === this.original);
   moveItemInArray(this.displayedColumns, _index, 1);
}

canSelection(value: string): boolean {
   return this.displayedColumns.some(v => v === value);
}

addNewLang(number) {
   this.setEdit();
   this.displayedColumns.push('temp' + number);
   this.setPosition();
}

drop(event: CdkDragDrop<any[]>) {
   moveItemInArray(this.dataSource.data, event.previousIndex, event.currentIndex);
   this._renderSource();
   this.setEdit();
}

onInvalidDragEventMouseDown(b) {
   this.isInvalidDragEvent = b;
}

check(): boolean {
   return this.langSupport.length <= (this.displayedColumns.length - 2);
}

dragStarted() {
   if (this.isInvalidDragEvent) {
      document.dispatchEvent(new Event('mouseup'));
   }
}

openEditDialog(column) {
   const _obj = this.dataSource.data.map(v => v[column]);
   const _dialog =  this.dialog.open(EditDialogComponent, { disableClose: true, data: _obj});
   const _mustbeAddMore = (_source, _target) => {
      if (_source < _target) {
         let _count = _target - _source;
         while (_count !== 0) {
          this.addRows();
          _count--;
         }
      }
   };
   _dialog.afterClosed().subscribe(v => {
      if (v) {
       _mustbeAddMore(this.dataSource.data.length, v.length);
       v.forEach((_val, index) => {
          this.dataSource.data.forEach((_val2, index2) => {
             if (index === index2) {
                _val2[column] = _val;
             } else if (index < index2) {
                _val2[column] = '';
             }
          });
       });
      }
   });
 }

resetValue(resetLang: string) {
   this.dataSource.data.forEach(obj => {
      for (const key in obj) { if (key === resetLang) { obj[key] = ''; } }
   });
   this.setEdit();
}

selectLangs(newColumn: string, oldColumn, cId) {
   let _newIndex;
   _newIndex = newColumn.startsWith('temp') ? 'temp' + this._dynamicIndex++ : newColumn;

   this.displayedColumns[cId] = _newIndex;
   this.dataSource.data.forEach(v => {
      v[_newIndex] = v[oldColumn];
      v[oldColumn] = '';
   });
   this._sortOriginal();
   this.setEdit();
}

duplicateRow(langKey, _index) {
   const _indexTemp = _index + 1;
   const _sourceTemp = [];
   const _pushTemp = (obj: Object) => {
      for (const key in obj) {
         if (key === langKey) {
            _sourceTemp.push(obj[key] === '' ? '' : obj[key]);
         }
      }
   };
   this.duplicateType = langKey;
   let _displayIndex;
   _displayIndex = 'temp' + this.displayedColumns.length;
   this.displayedColumns.splice(_indexTemp, 0, _displayIndex);
   this.dataSource.data.forEach(obj => _pushTemp(obj));

   this._duplicateRow(_displayIndex, _sourceTemp);
   this.setEdit();
}

private _duplicateRow(langKey: string, obj: Array<string>) {
   const _reAssign = (index2, v2) => {
      obj.forEach((v, index) => {
         if (index2 === index) { v2[langKey] = v; }
      });
   };
   this.dataSource.data.forEach((v2, index2) => _reAssign(index2, v2));
}

private _sortOriginal(): void {
   const _index1 = this.displayedColumns.findIndex(v => v === this.original);
   if (_index1 !== -1) { moveItemInArray(this.displayedColumns, _index1, 1); }
}

deleteActions(column): void {
   const data = {
      message: this.helperTranslater.getTagEform('msg.aware-delete-column'),
      ok: {
         color: 'primary',
         label: this.helperTranslater.getTagEform('button.yes'),
         action: () => this._deleteAction(column)
      },
      close: {
         label: this.helperTranslater.getTagEform('button.no'),
         action: () => true
      }
   };
   this.dialog.open(MessageBoxComponent, { disableClose: true, data });
}

private _deleteAction(resetLang: string) {
   this.resetValue(resetLang);
   this.displayedColumns.splice(this.displayedColumns.indexOf(resetLang), 1);
   this.setEdit();
   return true;
}

private _renderSource() {
   this.dataSource.data = [...this.dataSource.data];
}

checkErrors(_value: string) {
   return _value === '' ? true : false;
}

setEdit() {
   if (!this.isEdit) { this.isEdit = true; }
}

localName(lid: string) {
   let _text;
   this.translate.get('eform.lang').subscribe(v => {
      _text = v[lid];
   });
   return _text;
}

containingTmp() {
   let _boolean = false;
   this.displayedColumns.forEach(v => {
      if (v.startsWith('temp')) {
         _boolean = true;
      }
   });
   return _boolean;
}

save(): void {
   const data = {
      message: this.helperTranslater.getTagEform('msg.aware-containing-cancel-save'),
      ok: {
         color: 'primary',
         label: this.helperTranslater.getTagEform('button.yes'),
         action: () => this._ok()
      },
      close: {
         label: this.helperTranslater.getTagEform('button.no'),
         action: () => true
      }
   };
   this.containingTmp() ? this.dialog.open(MessageBoxComponent, { disableClose: true, data }) : this._ok();
}

addRows(index?) {
   const _val = {};
   Object.keys(this.dataSource.data[0]).forEach(key => {
         let _tmp: Object = {};
         if (key === 'id') {
            const _lastindex = this.dataSource.data.length - 1;
             _tmp = {[key]: _lastindex + 1};
         } else {
             _tmp = {[key]: ''};
         }
         Object.assign(_val, _tmp);
   });
   if (index !== '' && index !== undefined) {
      this.dataSource.data.splice(index + 1, 0, _val);
   } else {
      this.dataSource.data.push(_val);
   }
    this._renderSource();
    this.setEdit();
    setTimeout(() => { this.divs.last.nativeElement.focus(); }, 500);
}

deleteRow(index) {
   this.dataSource.data.splice(index, 1);
   this._renderSource();
   this.setEdit();
}

cancel(): void {
   const data = {
      message: this.helperTranslater.getTagEform('msg.aware-cancel-save'),
      ok: {
         color: 'primary',
         label: this.helperTranslater.getSingleTranslation('create_tasks.save'),
         action: () => this._ok()
      },
      close: {
         label: this.helperTranslater.getTagEform('button.dont-save'),
         action: () => this._close()
      }
   };
   this.isEdit ? this.dialog.open(MessageBoxComponent, { disableClose: true, data }) : this._close();
}

_ok() {
   this.saveSetup();
   return true;
}

saveSetup() {
   const _formGroup = this.data.field as FormArray;
   const _other = new FormGroup({'id': new FormControl(9001), 'th': new FormControl('อื่นๆ'), 'en' : new FormControl('Other'), 'cn' : new FormControl('Other')});
   const prepare = (_value, index) => {
      const _tmp =  new FormGroup({
            'id' : new FormControl(_value.id),
            'th' : new FormControl(_value.th),
            'en' : new FormControl(_value.en),
            'cn' : new FormControl(_value.cn),
      });
      _tmp.controls[this.original].setValidators(Validators.required);
      _tmp.controls[this.original].updateValueAndValidity();
      _tmp.updateValueAndValidity();
      _formGroup.push(_tmp);
      if (!_value.th && !_value.en && !_value.cn) {
         _formGroup.removeAt(index);
         this.deleteRow(index)
      }
   };
   _formGroup.clear();
   this.dataSource.data.forEach((v, index)=> {
      prepare(v,index);
   });

   _formGroup.controls.forEach(v => {
      if (v.value[this.original]) {
         this.languageList.forEach(lang => {
            if (lang !== this.original && v.get(lang) && !v.get(lang).value) {
               v.get(lang).setValue(v.value[this.original]);
            }
         });
      }
   });
   _formGroup.updateValueAndValidity();

   _formGroup.push(_other);
   this._close();
}

_close() {
   this.dialog.closeAll();
   return true;
}



}
